import {
    matrixFieldsActions,
    userActions,
    useSelector
} from "inbooma-api";
import React, {useEffect, useState} from "react";
import {Biscuit, getAllUrlParams} from "../../../../../utils";
import showNotification from "../../../../helpers/showNotification";
import t from "../../../../helpers/t";
import {isViewVisible} from "../../../../../utils/ViewSettings";
import {$, moment} from "../../../../../../vendor";
import UserSidebar from "./UserSidebar";
import InboomaSubmenu from "../../../../components/InboomaSubmenu";
import SortNav from "../../../../components/SortNav";
import Paginator from "../../../../components/paginator";
import UsersList from "./UsersList";
import Loader from "../../../../components/Loader";
import ItemView from "./ItemView";
import {getUserString} from "../../../../../utils/Helper";

const UsersView = (props) => {
    const { dispatch, params, action, returnPath } = props;
    const currentUrl = new URL(window.location.href);
    if(params.userId !== null){params.add = false;}
    const language = Biscuit.get('user.lang').replace('-','_');
    const searchParams = currentUrl.searchParams;
    const allUrlParams = getAllUrlParams(window.location.href);
    const paginationLimit = 40;
    const [pagination,setPagination] = useState({
        has_next_page: false,
        current_page: 1
    });
    let mainMenu = document.getElementById('inb-main-menu');
    if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector('.l-users')) {
        if (mainMenu.querySelector('.active') != null) mainMenu.querySelector('.active').classList.remove('active');
        mainMenu.querySelector('.l-users').classList.add('active');
    }
    const [filters, setFilters] = useState({
        'find': action === 'staff' ? 'IsEmployee' : '!IsEmployee',
        'sort': 'created',
        'direction': 'desc',
        'limit': paginationLimit,
        'page' : pagination.current_page,
        'withTrashed': true,
        ...allUrlParams
    });
    const _queryState = {
        timeStamp: 0,
        value: ""
    }
    let ownRole = Biscuit.get('user.role');
    /*
       Roles gradation  lowest to highest
       0: user
       1: garage-staff
       2: manager-location
       3: mediator
       4: booking-manager
       5: manager
       6: admin
     */
    const roleGradiations = {
        0: 'user',
        1: 'garage-staff',
        2: 'manager-location',
        3: 'mediator',
        4: 'booking-manager',
        5: 'manager',
        6: 'admin'
    };
    const roleGradiationsRevers = {
        'user':0,
        'staff':1,
        'manager-location':2,
        'mediator':3,
        'booking-manager':4,
        'manager':5,
        'admin':6
    };

    let roles = [];
    for(let i = 0; i <= roleGradiationsRevers[ownRole]; i++){
        if(i===0){
            if(ownRole !== 'staff') {
                roles.push(roleGradiations[i]);
            }
        } else {
            roles.push(roleGradiations[i]);
        }
    }

    const _users = useSelector(state => state.users_data.users);
    const _user = useSelector(state => state.users_data.user);
    const _duser = useSelector(state => state.users_data.findDeletedUser);
    const _ruser = useSelector(state => state.users_data.restoreDeletedUser);
    const _patchUser = useSelector(state => state.users_data.user);
    const _matrixFields = useSelector(state => state.matrix_fields_data.matrixFields);
    const _deleteUser = useSelector(state => state.users_data.deleteUser);
    const _userSummary = useSelector(state => state.users_data.getUserSummary);
    const [users, setUsers] = useState([]);
    const [user, setUser] = useState(null);
    const [usersPending,setUsersPending] = useState(false);
    const [userPending,setUserPending] = useState(false);
    const [patchUserPending,setPatchUserPending] = useState(false);
    const [editUserPending, setEditUserPending] = useState(null);
    const [deleteUserPending, setDeleteUserPending] = useState(null);
    const [initialized, setInitialized] = useState(false);
    const [userSummaryPending, setUserSummaryPending] = useState(false);
    const [userSummary,setUserSummary] = useState([]);
    const [targetUser, setTargetUser] = useState(null);

    useEffect(() => {
        if(!initialized && !usersPending && !userPending && !userSummaryPending){
            dispatch(userActions.getUserResetData());
            dispatch(matrixFieldsActions.getMatrixFields(
                {
                    filter: {
                        client_id: Biscuit.get('user.client_id'),
                        active_be: 1,
                        webname: 'default'
                    },
                    parameters: {
                        headers: {
                            "Accept-Language": language
                        }
                    }
                }
            ));
            let requestFilter = {...filters};
            requestFilter = {...requestFilter, page: pagination.current_page};
            requestFilter = {...requestFilter, limit: paginationLimit};
            requestFilter = {...requestFilter, ...allUrlParams};
            requestFilter = {...requestFilter, withTrashed: true};
            dispatch(userActions.getUsers({
                    'token': Biscuit.get('token'),
                    filter: requestFilter,
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }
            ));
            setUsersPending(true);
            if(params.userId !== null) {
                dispatch(userActions.getUser({
                        'token': Biscuit.get('token'),
                        id: params.userId,
                        filter: {withTrashed: true},
                        parameters: {
                            headers: {
                                'Accept-Language': language,
                                'Content-Language': language
                            }
                        }
                    }
                ));
                setUserPending(true);
            }
        }
    }, [])
    useEffect(() => {
        if (_patchUser.success === "" || !patchUserPending) return;
        console.log('in patch user')
        if (_patchUser.success === true) {
            // update user in list
            for (let i=0;i<users.length;i++) {
                if (users[i].id === _patchUser.data.id) {
                    const clone = [...users];
                    clone[i].active = _patchUser.data.active;
                    setUsers(clone);
                    break;
                }
            }

            showNotification('success', getUserString(targetUser), null, 'user');
        } else {
            let message = _patchUser.data.message;
            showNotification('warning', getUserString(targetUser), message, 'user');
        }
        setPatchUserPending(false);

        setEditUserPending(null);
        if(!usersPending && !deleteUserPending && !userSummaryPending){
            setInitialized(true)
        }
    },[_patchUser]);

    useEffect(() => {
        if (_user.success === "" || !userPending) return;

        if (_user.success === true) {
            setUser(_user.data);
            setUserPending(false);
        } else {
            if(typeof _user?.data?.code !== 'undefined' && _user?.data?.code === 404){
                // not found, we try to find the deleted
                dispatch(userActions.findDeletedUserResetData());
                dispatch(userActions.findDeletedUser({
                    'token': Biscuit.get('token'),
                    'id': params.userId,
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
            }
        }

        if(!usersPending && !deleteUserPending && !userSummaryPending && !userPending){
            setInitialized(true)
        }
    },[_user]);

    useEffect(() => {
        if (_duser.success === "" || !userPending) return;

        if (_duser.success === true) {
            setUser(_duser.data);

        } else {
                let message = _duser.data.message;

                showNotification('warning', null, message, 'user');
        }
        setUserPending(false);
        if(!usersPending && !deleteUserPending && !userSummaryPending){
            setInitialized(true)
        }
    },[_duser]);

    useEffect(() => {
        if (_users.success === "" || !usersPending) return;

        if (_users.success === true) {
            setUsers(_users.data);
            setPagination(_users.pagination);
        } else {
            let message = _users.data.message;
            showNotification('warning', null, message, 'user');
        }
        setUsersPending(false);
        if(!userPending && !deleteUserPending && !userSummaryPending){
            setInitialized(true)
        }
    },[_users]);

    useEffect(() => {

        if (_deleteUser.success === "" || deleteUserPending === null) {
            return;
        }

        if (_deleteUser.success === true) {

            showNotification('success',getUserString(targetUser),'removed','user');
           /* let clone = [...users];
            clone.splice(deleteUserPending,1);
            setUsers(clone);*/
            // update user list
             props.dispatch(userActions.getUsers({
               token: Biscuit.get('token'),
               filter: filters,
               parameters: {
                 headers: {
                   'Accept-Language': language,
                   'Content-Language': language
                 }
               }
             }));
             setUsersPending(true);
        } else {
            let message = _deleteUser.data.message;

            showNotification('warning', getUserString(targetUser), message, 'user');
        }
        setDeleteUserPending(null);
    },[_deleteUser]);

    useEffect(() => {

        if (_ruser.success === "" || deleteUserPending === null) {
            return;
        }

        if (_ruser.success === true) {

            showNotification('success',getUserString(targetUser),'restored','user');

            // update user list
             props.dispatch(userActions.getUsers({
               token: Biscuit.get('token'),
               filter: filters,
               parameters: {
                 headers: {
                   'Accept-Language': language,
                   'Content-Language': language
                 }
               }
             }));
             setUsersPending(true);
        } else {
            let message = _ruser.data.message;

            showNotification('warning',getUserString(targetUser) , message, 'user');
        }
        setDeleteUserPending(null);
    },[_ruser]);

    useEffect(() => {
        if (userSummaryPending === false || _userSummary.success === "") {
            return;
        }
        if (_userSummary.success === true) {
            setUserSummary(_userSummary.data);
        } else {
            console.log("Failed fetching user summary!");
        }
        setUserSummaryPending(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[_userSummary]);

    useEffect(() => {
        if(usersPending || userSummaryPending) return;
        props.dispatch(userActions.getUserSummary({
            token: Biscuit.get('token'),
            filter: filters,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setUserSummaryPending(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[users]);

    const getAvailableRoles = () => {

        //  let roles = ['admin','manager','booking-manager','mediator','manager-location','garage-staff'];         // these roles are always visible (admin is only selectable by other admins)

        //if (props.status.action != 'staff') roles.push('user');                                   // user is only hidden in sidebar filter

        //if (Biscuit.get('client.isVehicleOwner') === 'true') roles.push('manager-location');      // only vehicle owner have location managers

        // if (Number(Biscuit.get('user.client_id')) == 28 || Number(Biscuit.get('user.client_id')) == 49 || Number(Biscuit.get('user.client_id')) == 50) roles.push();              // only client 28 is using this role for now

        return roles;
    }

    const onSearchbarChanged = (ev) => {

        let query;
        if(typeof ev.target !== 'undefined') {
            query = ev.target.value.toLowerCase();
        } else {
            query = '';
        }
        searchParams.delete('q');
        if(query !== '') {
            searchParams.set('q', query);
        }
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);

        const minLength = 3;

        if (query.length >= minLength) {                                    // work user search only for values bigger or equal to the minimum length

            setTimeout(function () {

                let diff = Number(moment().format('x')) - _queryState.timeStamp;
                if (diff > 700 && _queryState.value === query) {                  // no changes after the last 700 ms -> user finished input -> start request
                      dispatch(userActions.getUsers({
                            token: Biscuit.get('token'),
                            filter: {
                                ...filters,
                                'q': query
                            },
                          parameters: {
                              headers: {
                                  'Accept-Language': language,
                                  'Content-Language': language
                              }
                          }
                        }));
                    setUsersPending(true);
                        setFilters({
                            ...filters,
                            'q': query
                        });
                    }
            },800);
        } else if (filters.q !== undefined) {
            // reset filter when query was active
             let clone = {...filters};
            delete clone.q;
            setFilters(clone);
            props.dispatch(userActions.getUsers({
                token: Biscuit.get('token'),
                filter: {
                    ...clone
                },
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setUsersPending(true);
        } else {
            let clone = {...filters};
            delete clone.q;
            setFilters(clone);
            props.dispatch(userActions.getUsers({
                token: Biscuit.get('token'),
                filter: {
                    ...clone
                },
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setUsersPending(true);
        }
        _queryState.timeStamp = Number(moment().format('x'));
        _queryState.value = query;
    };

    const onFilterChanged = (filter) => {

        const _filter = {'find': action === 'staff' ? 'IsEmployee' : '!IsEmployee','sort': 'created','direction': 'desc'};
        let clone = {...filter};

        Object.assign(clone,_filter);
        setFilters(clone);

        props.dispatch(userActions.getUsers({
            token: Biscuit.get('token'),
            filter: clone,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setUsersPending(true);
    };

    const loadNextPage = (page) => {
        setUsersPending(true);
        // request next page
        props.dispatch(userActions.getUsers({
            token: Biscuit.get('token'),
            filter: {
                ...filters,
                page: page,
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
    };

    const onChangeSort = (ev) => {

        const el = ev.currentTarget;

        const sortKey = el.getAttribute('data-inb-val'),
            direction = el.getAttribute('data-inb-direction'),
            isOppositeElement = (direction === null && el.classList.contains('is-active')),
            newDirection = (direction === 'desc' || isOppositeElement ? 'asc' : 'desc');

        if (sortKey) {
            let filter = {
                sort: sortKey,
                direction: direction
            };

            setFilters(Object.assign(filters, filter));

            props.dispatch(userActions.getUsers({
                token: Biscuit.get('token'),
                filter: filters,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setUsersPending(true);
            const activeSortTab = $('.is-active');

            for (let tab=0;tab<activeSortTab.length;tab++) {
                activeSortTab[tab].classList.remove('is-active');
            }
            el.classList.add('is-active');
            el.setAttribute('data-inb-direction', (isOppositeElement ? 'desc' : newDirection));
        }
    };

    const onChangeUserActive = (e,user) => {
        setTargetUser(user);
        props.dispatch(userActions.editUser({
            id: user.id,
            active: (e.target.checked ? 1 : 0),
            token: Biscuit.get('token')
        }));
        setPatchUserPending(true);
        setEditUserPending(user.id);
    };

    const onDeleteUser = (user,key) => {
        // show warning
        if (confirm(t('really_remove'))) {
            setTargetUser(user);
            props.dispatch(userActions.deleteUser({
                id: user.id,
                token: Biscuit.get('token')
            }));
            setDeleteUserPending(key);
        }
    };

    const onRestoreUser = (user,key) => {
        // show warning
        if (confirm(t('really_restore_user'))) {
            setTargetUser(user);
            props.dispatch(userActions.restoreDeletedUser({
                id: user.id,
                token: Biscuit.get('token')
            }));
            setDeleteUserPending(key);
        }
    };

    const submenuItems = [
        {
            name: t('users',null,'capital'),
            link: 'users',
            data_inb_val: 'users',
            icon: 'fi fi-address-book',
            isActive: (action === 'users' || params.id !== null || params.add),
            isAccessible: isViewVisible('users','users')
        },{
            name: t('staff',null,'capital'),
            link: 'users/staff',
            data_inb_val: 'staff',
            icon: 'fi fi-torsos-all',
            isActive: action === 'staff',
            isAccessible: isViewVisible('staff','users')
        },{
            name: t('usergroups',null,'capital'),
            link: 'usersExtension/userGroups',
            data_inb_val: 'groupList',
            icon: 'fi fi-torsos-all',
            isActive: false,
            isAccessible: isViewVisible('groupList','users')
        },{
            name: t('messages',null,'capital'),
            link: 'usersExtension/messages',
            data_inb_val: 'messages',
            icon: 'fi fi-mail',
            isActive: false,
            isAccessible: isViewVisible('messages','users')
        }
    ];

    let tabs = [{
        name: 'ID',
        smallWidth: 8,
        mediumWidth: 8,
        extraClasses: 'column large-2',
        title: t('sort_by_${a}', {a: t('ID')}, 'capital'),
        canSort: true,
        sort: {
            direction: 'desc',
            data_inb_val: 'customer_nbr'
        }
    }, {
        name: t('name', null, 'capital'),
        smallWidth: 8,
        mediumWidth: 8,
        extraClasses: 'column large-2',
        title: t('name', null, 'capital'),
        canSort: true,
        sort: {
            direction: 'asc',
            data_inb_val: 'last_name'
        }
    }, {
        name: t('username', null, 'capital'),
        smallWidth: 8,
        mediumWidth: 8,
        extraClasses: 'column large-2',
        title: t('sort_by_${a}', {a: t('username')}, 'capital'),
        canSort: true,
        sort: {
            direction: 'asc',
            data_inb_val: 'username'
        }
    }, {
        name: t('email'),
        smallWidth: 8,
        mediumWidth: 8,
        extraClasses: 'column large-2',
        title: t('sort_by_${a}', {a: t('email')}, 'capital'),
        canSort: true,
        sort: {
            direction: 'asc',
            data_inb_val: 'email'
        }
    }
    ];


    if (action === 'staff') {
        tabs.push({
            name: t('role', null, 'capital'),
            smallWidth: 1,
            mediumWidth: 1,
            extraClasses: 'large-1',
            title: t('role', null, 'capital'),
            canSort: true,
            sort: {
                direction: 'desc',
                data_inb_val: 'role'
            }
        });
    }
    tabs.push({
        name: t('created_at', null, 'capital'),
        smallWidth: 8,
        mediumWidth: 8,
        extraClasses: 'column large-2',
        title: t('created_date', null, 'capital'),
        canSort: true,
        sort: {
            direction: 'desc',
            data_inb_val: 'created'
        }
    });

    return (<>
        <UserSidebar
            setSelectedFilter={onFilterChanged}
            activeSubmenu={action === 'staff' ? 'staff' : 'user'}
            getAvailableRoles={getAvailableRoles}
            userSummaryPending={userSummaryPending}
            userSummary={userSummary}
        />
        <div id="inb-c-main" className="columns user">
            <InboomaSubmenu
                tabs={submenuItems}
                extraClasses={"sticky-top"}
                searchbar={true}
                searchbarPlaceholder={t('username') +' / ID / '+ t('e-mail')}
                searchbarValue={allUrlParams?.q !== undefined ? allUrlParams.q : ""}
                searchbarHandler={onSearchbarChanged}
                smallOnlyTitle={t('users',null,'capital')}
                pagination={pagination}
                itemsCountPerPage={paginationLimit}
                pageRangeDisplayed={5}
                onChange={loadNextPage}
                initialized={initialized}
                itemLength={users.length}
            />
            <SortNav
                tabs={tabs}
                /* margStyle={"15px"} */
                extraClasses={"sticky-top-sortbar"}
                listStyle="tight"
                handler={onChangeSort}
            />
            {/* {typeof pagination !== 'undefined' &&
                <Paginator
                    pagination={pagination}
                    itemsCountPerPage={paginationLimit}
                    pageRangeDisplayed={5}
                    onChange={loadNextPage}
                    upper={true}
                />} */}
            {!usersPending && users.length > 0 &&
               <UsersList
                   users={users}
                   action={action}
                   deleteUserPending={deleteUserPending}
                   onDeleteUser={onDeleteUser}
                   onRestoreUser={onRestoreUser}
                   editUserPending={editUserPending}
                   currentUrl={currentUrl}
                   onChangeUserActive={onChangeUserActive}
                   />
            }
            {!usersPending && users.length < 1 &&
            <>
                <div
                    id="inb-app-collection-empty"
                    className="inb-announcement"
                >
                    <div className="inb-image-box">
                        <img alt="No Data" src={"assets/img/no_data.svg"}/>
                    </div>
                    <h3>
                        {t('app_msg_collection_empty')}
                    </h3>
                    <p>
                        {t('app_msg_collection_empty_body')}
                    </p>
                </div>
            </>}
            {usersPending && <Loader
                mediumWidth={2}
                smallWidth={4}
                subLoaders={5}/>}
        </div>
        {console.log(params)}
        {(_matrixFields.data.length > 0 && (params.add || (params.userId !== null && !userPending))) &&
            <ItemView
                user={user}
                matrixFields={_matrixFields.data}
                showNotification={showNotification}
                requestPath={returnPath}
                dispatch={dispatch}
                getAvailableRoles={getAvailableRoles}
            />
        }
        </>);

}

export default UsersView;